import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { NIPRJWICSPage } from './pages/NIPRJWICSPage';
import { ThoughtLeadershipPage } from './pages/ThoughtLeadershipPage';
import { CalculatorPage } from './pages/CalculatorPage';
import { CaseStudiesPage } from './pages/CaseStudiesPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AppLayout() {
  return <div className="min-h-screen flex flex-col" data-id="element-0">
      <Navigation data-id="element-1" />
      <main className="flex-1" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/services" element={<ServicesPage data-id="element-7" />} data-id="element-6" />
          <Route path="/nipr-jwics" element={<NIPRJWICSPage data-id="element-9" />} data-id="element-8" />
          <Route path="/thought-leadership" element={<ThoughtLeadershipPage data-id="element-11" />} data-id="element-10" />
          <Route path="/calculator" element={<CalculatorPage data-id="element-13" />} data-id="element-12" />
          <Route path="/case-studies" element={<CaseStudiesPage data-id="element-15" />} data-id="element-14" />
        </Routes>
      </main>
      <Footer data-id="element-16" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-17">
      <ScrollToTop data-id="element-18" />
      <AppLayout data-id="element-19" />
    </BrowserRouter>;
}